import {globalRowsPerPageOptions} from 'utils/const/globalConst'
import {pageSizeActionTypes} from '../actionTypes'

const initialState = {
  pageSize: 30,
  selectPageSize: globalRowsPerPageOptions,
}

const pageSizeControlReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case pageSizeActionTypes.PAGE_SIZE_UPDATE:
      return {
        ...state,
        pageSize: action.payload.pageSize,
        selectPageSize: globalRowsPerPageOptions,
      }

    default:
      return state
  }
}

export default pageSizeControlReducer
